import YaCounter from "../ym";
import {VGSidebar} from "vgnav/src/VGSidebar";
import VGMask from "../../../../../../modules/vegas/js/mask";

window.VegasCatalog.Cart = {
	add: function (id, cnt, params, callback) {
		params = params || {};
		params.id = id;
		params.cnt = cnt || 1;
		params._token = App.csrf;

		this.addRequest(params, callback);
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Добавлено в корзину');

			new YaCounter().goal('add-to-cart');
		});
	},

	changeCnt: function (id, cnt, appendParams, callback) {
		let params = appendParams || {};
		params.id = id;
		params.cnt = cnt;
		params = VegasCatalog.Cart.formData(params);

		$.post('/cart/change_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
		});
	},

	remove: function (id, callback) {
		let params = {};
		params.id = id;
		params._token = App.csrf;

		this.removeRequest(params, callback);
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Убрано из корзины');
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter=products]').attr('data-cnt', data.products_count);
		}

		this.totalCartForm(data);
		this.totalCartProducts(data);
	},

	totalCartForm: function (data) {
		let $cart = $('#vg-cart-products');

		// products sum
		let $sProducts = $cart.find('[data-sum="products"]');
		$sProducts.find('[data-sum-value]').text(output_roubles(data.sums.sum));

		// cart sum
		let $sCart = $cart.find('[data-sum="total"]');
		$sCart.find('[data-sum-value]').text(output_roubles(data.sums.sum));

		// delivery sym
		let $sDelivery = $cart.find('[data-sum="delivery"]');
		if (data.sums.sum_delivery !== null) {
			$sDelivery.find('[data-sum-value]')
				.text(
					isNaN(data.sums.sum_delivery) ? data.sums.sum_delivery : (
						data.sums.sum_delivery > 0 ? output_roubles(data.sums.sum_delivery) : 'бесплатно'
					)
				);
			$sDelivery.show();
		} else {
			$sDelivery.hide();
		}
	},

	totalCartProducts: function (data) {
		let $cartProducts = $('.catalog-cart--products');
		if ($cartProducts.length && typeof data.products_totals !== 'undefined') {
			for (let i in data.products_totals) {
				let p = data.products_totals[i];

				$cartProducts.find('[data-product-cart-item][data-pivot_id="' + p.pivot_id + '"]')
					.find('.price-total')
					.text(output_roubles(p.price_total));
			}
		}
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = $('#form-cart').serializeArray();

		if (!resultParams.length) {
			resultParams.push({name: '_token', value: App.csrf});
		}

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		return resultParams;
	},

	setCartState: function (state) {
		let $cart = $("#sidebar-cart");
		$cart.attr('data-current-state', state);
	},

	syncProducts: function ($product, data = {}) {
		if (!$product)
			return false;

		let id = $product.data('id');

		let $products = $(`[data-product-item][data-id=${id}]`);

		if (typeof data.in_cart === 'undefined') {
			data.in_cart = $product.hasClass('in-cart');
		}

		if (typeof data.count === 'undefined') {
			let count = parseInt($product.find('input[name=cnt]').val());
			if (!isNaN(count)) {
				data.count = count;
			}
		}

		$products.each(function (i, p) {
			if ($(p) == $product)
				return;

			if (data.in_cart) {
				$(p).addClass('in-cart');
			} else {
				$(p).removeClass('in-cart');
				$(p).find('[data-cart][data-action="del"]').attr('data-action', 'add');
				data.count = 1;
			}

			if (data.count) {
				$(p).find('input[name=cnt]').val(data.count);
			}

			if (data.price_total) {
				$(p).find('[data-total-price]').html(output_roubles(data.price_total))
			}
		});
	},
};

let $document = $(document);

/** PRODUCT LIST **/
$document.on('click', '[data-product-item] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.addClass('in-cart');
	$btn.attr('data-action', 'del');

	VegasCatalog.Cart.add(id);
	VegasCatalog.Cart.syncProducts($product);

	return false;
});
$document.on('click', '[data-product-item] [data-cart][data-action=del]', function () {
	let $product = $(this).closest('[data-product-item]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.removeClass('in-cart');
	$btn.attr('data-action', 'add');

	VegasCatalog.Cart.remove(id);
	VegasCatalog.Cart.syncProducts($product);

	return false;
});
$document.on('click', '[data-product-item] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product-item]');
	let id = $product.data('id');
	let $btn = $product.find('[data-cart][data-action]');

	$product.removeClass('in-cart');
	$btn.attr('data-action', 'add');

	VegasCatalog.Cart.remove(id);
	VegasCatalog.Cart.syncProducts($product);

	return false;
});
$document.on('change-counter', '[data-product-item] [data-cart="qty"]', function (e, data) {
	let $product = $(this).closest('[data-product-item]');
	let id = $product.data('id');
	VegasCatalog.Cart.changeCnt(id, data.count);

	$product.find('[data-total-price]').html(output_roubles(data.price_total));

	VegasCatalog.Cart.syncProducts($product, {
		count: data.count,
		price_total: data.price_total
	});

	return false;
});

/** PRODUCT SHOW **/
$document.on('click', '[data-product] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product]');
	let $btn = $(this);
	let id = $product.data('id');

	$product.addClass('in-cart');

	VegasCatalog.Cart.add(id);

	VegasCatalog.Cart.syncProducts($product);

	return false;
});
$document.on('click', '[data-product] [data-cart][data-action=del]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	$product.removeClass('in-cart');

	VegasCatalog.Cart.remove(id);
	VegasCatalog.Cart.syncProducts();

	return false;
});
$document.on('change-counter', '[data-product] [data-cart="qty"]', function (e, data) {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	$product.find('[data-total-price]').html(output_roubles(data.price_total));

	VegasCatalog.Cart.changeCnt(id, data.count);

	VegasCatalog.Cart.syncProducts($product, {
		count: data.count,
		price_total: data.price_total
	});

	return false;
});
$document.on('click', '[data-product] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	$product.removeClass('in-cart');
	VegasCatalog.Cart.remove(id);
	VegasCatalog.Cart.syncProducts($product);

	return false;
});

/** PRODUCT CART ITEM */
$document.on('change-counter', '[data-product-cart-item] [data-cart="qty"]', function (e, data) {
	let $product = $(this).closest('[data-product-cart-item]');
	let id = $product.data('id');

	VegasCatalog.Cart.changeCnt(id, data.count, {
		get_products_totals: true
	});

	VegasCatalog.Cart.syncProducts($product, {
		count: data.count,
		price_total: data.price_total,
		in_cart: true,
	});

	return false;
});
$document.on('click', '[data-product-cart-item] [data-cart][data-action="del"]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let id = $product.data('id');
	$product.remove();

	let cnt = $('.catalog-cart--products [data-product-cart-item]').length;
	$("#vg-cart-products").attr('data-products-count', cnt);

	VegasCatalog.Cart.remove(id);
	VegasCatalog.Cart.syncProducts($product); // todo

	return false;
});

$('[data-cart][data-action=cart]').click(function () {
	new VGSidebar(this, {
		ajax: {
			target: "sidebar-cart-content",
			route: $(this).data('route')
		}
	}).open({
		beforeOpen: function () {
			VegasCatalog.Cart.setCartState('cart');
		}
	});

	return false;
});

$document.on('click', '[data-cart][data-action=to-order]', function () {
	VegasCatalog.Cart.setCartState('order');

	let $orderContainer = $('#vg-cart-order');
	let route = $orderContainer.data('route');

	$.get(route, {}, function (html) {
		$orderContainer.html(html);
		VGMask.init();
		$orderContainer.find('.nice-select').niceSelect();
	});

	return false;
});

$document.on('click', '[data-cart][data-action=to-offer]', function () {
	VegasCatalog.Cart.setCartState('offer');

	return false;
});

$document.on('click', '[data-btn-to-product]', function () {
	new VGSidebar(this).close();
});

$document.on('click', '.vg-sidebar-back', function () {
	$(".vg-sidebar-back").removeClass('show');
	VegasCatalog.Cart.setCartState('cart');
	return false;
});
